import * as yup from "yup";

export const emailFormSchema = yup
  .object({
    email: yup.string().email("E-mail inválido").required("E-mail é obrigatório").trim(),
  })
  .required();

export const codeFormSchema = yup
  .object({
    code: yup.string().length(6, "O código deve ter 6 dígitos").required("Código é obrigatório"),
  })
  .required();

export const recoveryPasswordFormSchema = yup
  .object({
    password: yup
      .string()
      .min(8, "A senha contém menos do que 8 caracteres")
      .required("Senha é obrigatória")
      .trim(),
    confirmPassword: yup
      .string()
      .min(8, "A senha contém menos do que 8 caracteres")
      .required("Digite novamente a senha")
      .oneOf([yup.ref("password")], "As senhas estão diferentes")
      .trim(),
  })
  .required();

export type EmailFormData = yup.InferType<typeof emailFormSchema>;
export type CodeFormData = yup.InferType<typeof codeFormSchema>;
export type RecoveryPasswordFormData = yup.InferType<typeof recoveryPasswordFormSchema>;
